import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import s from './ModelList.module.scss';
import { FormattedMessage, injectIntl } from 'react-intl';
import LoadingSpinner from '../LoadingSpinner/LoadingSpinner';
import Banner from '../Banner/Banner';
import { initialModelState } from '../../reducers/initialState';
import { Link, useParams } from 'react-router-dom';
import Pagination from '../Pagination/Pagination';
import { DEFAULT_PAGE_SIZE, ModelCategoryPermission } from '../../constants';
import ModelListTable from '../ModelList/ModelListTable';
import { IsWidgetAccessible } from '../../utils/widgetManager';
import SearchBar from '../SearchBar/SearchBar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import ModelCategoryConfigurationContentTemplate from '../ModelCategoryTab/ModelCategoryConfigurationContentTemplate';
import Button from 'react-bootstrap/Button';
import { WidgetVisibility } from '../../utils/widgetManager';
import Cookies from 'js-cookie';
import Breadcrumb from '../WSAControls/Breadcrumb/BreadCrumb'
import { getModelCategoryPermission } from '../../utils';




const ModelList = ({
  getModels,
  setCurrentPage,
  setFilterData,
  modelManager = {
    ...initialModelState.modelManager
  },
  intl,
  userProfileWidgets,
  userModelCategories,
  modelCleanUp,
  currentTimezone
}) => {
  let filter = modelManager.filter || '';
  let offset = modelManager.offset || 0;
  let limit = modelManager.limit || 1000;
  const envName = process.env.REACT_APP_ENV_NAME_SHORT;
  let organisationId = Cookies.get(`selectedorganisationid-${envName}`) || 1;
  let { ModelCategoryId } = useParams();

  useEffect(() => {
    getModels(offset, limit, filter, organisationId, ModelCategoryId);
  }, [getModels, offset, limit, filter, organisationId, ModelCategoryId]);


  useEffect(() => {
    return () => {
      modelCleanUp({ ...initialModelState.modelManager });
    };
  }, []);

  const onPageChangeHandler = currentPage => {
    setCurrentPage(currentPage);
  };

  const searchHandler = value => {
    setCurrentPage(1);
    filteredResults(value);
  };

  const filteredResults = value => {
    let filteredList = modelManager.models;

    if (value !== '') {
      filteredList = filteredList.filter(function (item) {
        return item.Name.toLowerCase().includes(value.toLowerCase());
      });
    }

    setFilterData({ filteredResults: { filteredResults: filteredList } });
  };

  const modelObj = Object.values(modelManager.filteredResults);

  let messageId = (modelManager && modelManager.displayMessageCode) || 'none';
  const messageText = intl.formatMessage({ id: messageId, defaultMessage: messageId });

  const isUpdateAllowed = IsWidgetAccessible(userProfileWidgets, 'MODEL_UPDATE');
  const isDuplicateAllowed = IsWidgetAccessible(userProfileWidgets, 'MODEL_DUPLICATE');
  const isConfigurationAllowed = IsWidgetAccessible(userProfileWidgets, 'MODEL_CONFIGURE');


  const breadcrumbItems = [
    { label: <FormattedMessage id="modelcategory.modelcategory" defaultMessage="Model Category" />, href: '/operational-setup/model-category-list' },
    { label: <FormattedMessage id="model.models" defaultMessage="Models" /> } // Last item has no href (current page)
  ];

  let IsCategoryOwner = getModelCategoryPermission(userModelCategories, ModelCategoryId, ModelCategoryPermission.Owner)

  return (
    <div className={s.model}>
      {modelManager.isLoading && <LoadingSpinner />}
      <Banner
        failureText={messageText}
        showBanner={modelManager.showBanner}
        status={modelManager.isOpSuccessful}
        successText={messageText}
      />
      <ModelCategoryConfigurationContentTemplate selectedPage="manageModels" userProfileWidgets={userProfileWidgets}>
        <div className={s.contentWrapper}>
          <div className={s.modelHeader}>
            <div className={s.subHeading}>
              <FormattedMessage id="model.models" defaultMessage="Models" />
              <span data-unittest="modelDataCount" className={s.circle}>
                {modelManager.models.length}
              </span>
            </div>
          </div>
          <div className='pb-3'>
            <Breadcrumb items={breadcrumbItems} />
          </div>
          <Row className={s.titleRows}>
            <Col sm={6} lg={4}>
              <SearchBar
                searchHandler={searchHandler}
                clearSearchInVisible={false}
                initialText={filter}
                placeHolderTextId="model.modelName"
              />
            </Col>
            <Col sm={6} lg={8}>
              { IsCategoryOwner &&
                <Link to={`/operational-setup/model-category-configuration/${ModelCategoryId}/model/0`}>
                  <Button className={s.addbutton} style={WidgetVisibility(userProfileWidgets, `MODEL_ADD`)}>
                    + <FormattedMessage id="model.addNew" defaultMessage="ADD NEW" />
                  </Button>
                </Link>}
            </Col>
          </Row>
          <div className="">
            <Pagination
              data={modelObj}
              pageSize={DEFAULT_PAGE_SIZE}
              onPageChange={onPageChangeHandler}
              startingPage={modelManager.currentPage}
            >
              <ModelListTable
                ModelCategoryId={ModelCategoryId}
                UpdateAllowed={isUpdateAllowed}
                DuplicateAllowed={isDuplicateAllowed}
                ConfigurationAllowed={isConfigurationAllowed}
                currentTimezone={currentTimezone}
                IsCategoryOwner={IsCategoryOwner}
              />
            </Pagination>
          </div>
        </div>
      </ModelCategoryConfigurationContentTemplate>
    </div>
  );
};


ModelList.propTypes = {
  getModels: PropTypes.func.isRequired,
  setCurrentPage: PropTypes.func.isRequired,
  setPageFilter: PropTypes.func.isRequired,
  currentTimezone: PropTypes.string.isRequired
};

export default injectIntl(ModelList);
